(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dispositivo', {
            parent: 'entity',
            url: '/dispositivo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.dispositivo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispositivo/dispositivos.html',
                    controller: 'DispositivoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispositivo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dispositivo-detail', {
            parent: 'entity',
            url: '/dispositivo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.dispositivo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispositivo/dispositivo-detail.html',
                    controller: 'DispositivoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispositivo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dispositivo', function($stateParams, Dispositivo) {
                    return Dispositivo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dispositivo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dispositivo-detail.edit', {
            parent: 'dispositivo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo/dispositivo-dialog.html',
                    controller: 'DispositivoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispositivo', function(Dispositivo) {
                            return Dispositivo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispositivo.new', {
            parent: 'dispositivo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo/dispositivo-dialog.html',
                    controller: 'DispositivoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dispositivo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dispositivo', null, { reload: 'dispositivo' });
                }, function() {
                    $state.go('dispositivo');
                });
            }]
        })
        .state('dispositivo.edit', {
            parent: 'dispositivo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo/dispositivo-dialog.html',
                    controller: 'DispositivoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispositivo', function(Dispositivo) {
                            return Dispositivo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispositivo', null, { reload: 'dispositivo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispositivo.delete', {
            parent: 'dispositivo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo/dispositivo-delete-dialog.html',
                    controller: 'DispositivoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dispositivo', function(Dispositivo) {
                            return Dispositivo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispositivo', null, { reload: 'dispositivo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
